export default {
  MuiPaper: {
    defaultProps: {
      elevation: 3,
    },
    styleOverrides: {
      root: {
        borderRadius: '18px',
        transition: 'background 0.5s ease-in-out',
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variant: 'body1',
    },
    // Resolves a `color` given as a palette path or a raw colour ('text.secondary', '#fff');
    // the named palette entries ('primary', 'textSecondary') Typography colours itself.
    variants: [
      {
        props: ({ color }) => typeof color === 'string' && /[.#(]/.test(color),
        style: ({ theme, color }) => ({
          color:
            color
              .split('.')
              .reduce((node, key) => node?.[key], theme.palette) ?? color,
        }),
      },
    ],
  },
  MuiButton: {
    defaultProps: {
      variant: 'contained',
    },
    styleOverrides: {
      root: {
        borderRadius: '25px',
      },
    },
  },
  MuiOutlinedInput: {
    defaultProps: {
      style: {
        borderRadius: '12px',
      },
    },
  },
};
